module.exports = __webpack_public_path__ + "img/pain_campagne_whole_done_2.58931e3e.jpg";